var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"bg-red-500 px-4 py-4 text-white rounded-lg my-8 whitespace-pre"},[_vm._t("default")],2)}
var staticRenderFns = []

export { render, staticRenderFns }